import moment from 'moment'
import api from '../../services/service_report'
import apipos from '../../services/service_pos'
import apiItem from '../../services/service_item'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      host_list: [],
      report_data: [],
      host: '',
      start_date: moment(new Date()),
      end_date: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: '',
      item_start: '',
      item_end: '',
      item_data: []
    }
  },
  methods: {
    getHost () {
      apipos.getHostShift(
        this.REST_URL,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            this.getReport()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getItems () {
      apiItem.listProduct(
        this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            result.data.forEach(val => {
              this.item_data.push({
                name: val['code'] + ': ' + val['name'],
                code: val['code']
              })
            })
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getReport () {
      var obj = {
        company_id: this.$store.state.user.company_id,
        branch_id: this.$store.state.user.branch_id,
        start_date: this.dateFormatDMY2(this.start_date),
        end_date: this.dateFormatDMY2(this.end_date),
        item_start: this.item_start.code,
        item_end: this.item_end.code
      }
      this.$store.commit('Loading')
      api.movementReport(
        this.REST_URL,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(result.data)
            this.form_host = JSON.stringify(this.host)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    count_qty (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_qty']
      })
      return sum
    },
    count_use (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_input']
      })
      return sum
    },
    count_input (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_use']
      })
      return sum
    },
    count_remain (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['sum_remain_qty']
      })
      return sum
    }
  },
  mounted () {
    this.checkUser()
    this.getHost()
    this.getItems()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/report_product_movement.js